import { useEffect, useState } from "react";
import { Check, Trash2, Plus } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";

export function IdeasAdmin() {
  const [list, setList] = useState(null);
  const [title, setTitle] = useState("");
  useEffect(() => { api.get("/admin/ideas").then(({ data }) => setList(data)).catch(() => setList([])); }, []);
  const act = (p, method = "post", body) => api[method](p, body).then(({ data }) => setList(data)).catch((e) => toast.error(formatErr(e)));
  if (!list) return null;
  const pending = list.filter((i) => i.status === "pending");
  const live = list.filter((i) => i.status !== "pending");
  const Row = ({ i }) => (
    <li className="flex items-center gap-3 rounded-2xl border border-pink-100 px-4 py-2.5" data-testid={`admin-idea-${i.id}`}>
      <span className="flex-1 text-sm font-semibold">{i.title}{i.by_name && <span className="block text-xs font-normal text-slate-400">von {i.by_name}</span>}</span>
      {i.status === "pending"
        ? <button type="button" onClick={() => act(`/admin/ideas/${i.id}/approve`).then(() => toast.success("Freigegeben"))} data-testid={`admin-idea-approve-${i.id}`} className="h-9 px-3 rounded-full bg-emerald-500 text-white text-xs font-bold inline-flex items-center gap-1"><Check className="w-4 h-4" /> Freigeben</button>
        : <span className="text-xs font-bold text-slate-500 tabular-nums">{i.votes} Stimmen</span>}
      <button type="button" onClick={() => window.confirm("Idee löschen?") && act(`/admin/ideas/${i.id}`, "delete")} data-testid={`admin-idea-delete-${i.id}`} className="w-9 h-9 rounded-full bg-rose-50 text-rose-600 inline-flex items-center justify-center"><Trash2 className="w-4 h-4" /></button>
    </li>
  );
  return (
    <div className="bg-white rounded-3xl p-5 sm:p-6 border border-pink-100 space-y-5" data-testid="admin-ideas">
      <div>
        <h3 className="font-display text-lg font-extrabold">Ideen-Abstimmung</h3>
        <p className="text-sm text-slate-500">Vorschläge der Community erscheinen erst nach deiner Freigabe.</p>
      </div>
      <form onSubmit={(e) => { e.preventDefault(); act("/admin/ideas", "post", { title: title.trim() }).then(() => setTitle("")); }} className="flex gap-2">
        <input value={title} onChange={(e) => setTitle(e.target.value)} maxLength={80} placeholder="Neue Idee" data-testid="admin-idea-input" className="flex-1 min-w-0 h-11 rounded-full border border-pink-200 px-4 text-sm outline-none" />
        <button type="submit" disabled={title.trim().length < 3} data-testid="admin-idea-add" className="shrink-0 h-11 px-4 rounded-full pink-gradient text-white text-sm font-bold inline-flex items-center gap-1 disabled:opacity-50"><Plus className="w-4 h-4" /> Hinzufügen</button>
      </form>
      <div>
        <p className="text-xs font-bold uppercase text-amber-600 mb-2">Wartet auf Freigabe ({pending.length})</p>
        {pending.length ? <ul className="space-y-2">{pending.map((i) => <Row key={i.id} i={i} />)}</ul> : <p className="text-sm text-slate-400">Keine offenen Vorschläge.</p>}
      </div>
      <div>
        <p className="text-xs font-bold uppercase text-slate-500 mb-2">Zur Abstimmung ({live.length})</p>
        <ul className="space-y-2">{live.map((i) => <Row key={i.id} i={i} />)}</ul>
      </div>
    </div>
  );
}
